import { createSlice } from "@reduxjs/toolkit";
import { VideoImageAPI } from "../../services/videos-image";

const MediaSlice = createSlice({
  name: "media",
  initialState: {
    mediaList: {},
  },
  reducers: {
    setMediaList: (state, action) => {
      state.mediaList = action.payload;
    },

    removeMediaItem: (state, action) => {
      const { mediaId, index } = action.payload;
      
      state.mediaList[mediaId] =
        state.mediaList[mediaId]?.filter((_, i) => i !== index).length > 0
          ? state.mediaList[mediaId]?.filter((_, i) => i !== index)
          : null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(VideoImageAPI.postMedia.fulfilled, (state, action) => {
      const {
        payload,
        meta: {
          arg: { mediaId },
        },
      } = action;

      if (mediaId) {
        state.mediaList[mediaId] = [
          ...(state.mediaList[mediaId] || []),
          ...payload,
        ];
      }
    });
  },
});

export const { setMediaList, removeMediaItem } = MediaSlice.actions;

export default MediaSlice;
